import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DcInputNumberPercentIndicativeFinalService {
  private updatesSubject = new BehaviorSubject<{ [key: string]: any }>({});
  updates$ = this.updatesSubject.asObservable();

  constructor() {}

  reset() {
    this.updatesSubject?.complete();
    this.updatesSubject = new BehaviorSubject<{ [key: string]: any }>({});
    this.updates$ = this.updatesSubject.asObservable();
  }

  updateValues(componentKey: string, values: any) {
    const currentUpdates = this.updatesSubject.getValue();
    const updatedValues = { ...currentUpdates, [componentKey]: values };
    this.updatesSubject.next(updatedValues);
  }
}
